/**
 * Sueco unified gift options.
 * Canonical cart linkage is line item property _gift_accessory_variant_ids.
 */
(function () {
  "use strict";

  var OMOTEGAKI_OPTIONS = {
    蝶結び: [
      { value: "御祝", desc: "お祝い全般" },
      { value: "内祝", desc: "お返し全般" },
      { value: "御礼", desc: "お礼・感謝" },
      { value: "お中元", desc: "夏のご挨拶" },
      { value: "お歳暮", desc: "冬のご挨拶" },
      { value: "お年賀", desc: "年始のご挨拶" },
      { value: "御挨拶", desc: "ご挨拶全般" },
      { value: "出産祝", desc: "ご出産のお祝い" },
      { value: "出産内祝", desc: "出産祝いのお返し" },
      { value: "入学祝", desc: "入学のお祝い" },
      { value: "卒業祝", desc: "卒業のお祝い" },
      { value: "新築祝", desc: "新築・引越しのお祝い" },
    ],
    結び切り: [
      { value: "寿", desc: "結婚祝い" },
      { value: "結婚内祝", desc: "結婚祝いのお返し" },
      { value: "快気祝", desc: "病気回復のお祝い" },
      { value: "快気内祝", desc: "お見舞いのお返し" },
      { value: "御見舞御礼", desc: "お見舞いへのお礼" },
    ],
    "掛け紙（法事用など）": [
      { value: "志", desc: "香典返し・法事のお返し" },
      { value: "御仏前", desc: "法事のお供え" },
      { value: "御霊前", desc: "通夜・葬儀のお供え" },
      { value: "御供", desc: "お供え物" },
      { value: "粗供養", desc: "法事の引き出物" },
    ],
  };

  document.querySelectorAll(".gift-options-wrapper").forEach(initWrapper);

  function initWrapper(wrapper) {
    var trigger = wrapper.querySelector(".gift-options__trigger");
    var panel = wrapper.querySelector(".gift-options__panel");
    var summary = wrapper.querySelector("[data-gift-summary]");
    var giftFlag = wrapper.querySelector("[data-gift-flag]");
    var selectedIdsInput = wrapper.querySelector(
      "[data-gift-accessory-variant-ids]",
    );

    var noshiBtn = wrapper.querySelector("[data-noshi-btn]");
    var noshiLabel = wrapper.querySelector("[data-noshi-label]");
    var noshiList = wrapper.querySelector("[data-noshi-list]");
    var noshiHidden = wrapper.querySelector("[data-noshi-value]");
    var noshiVariantHidden = wrapper.querySelector("[data-noshi-variant-id]");
    var noshiTogglePrice = wrapper.querySelector("[data-noshi-toggle-price]");

    var omotegakiBtn = wrapper.querySelector("[data-omotegaki-btn]");
    var omotegakiLabel = wrapper.querySelector("[data-omotegaki-label]");
    var omotegakiList = wrapper.querySelector("[data-omotegaki-list]");
    var omotegakiHidden = wrapper.querySelector("[data-omotegaki-value]");

    var cardBtn = wrapper.querySelector("[data-card-btn]");
    var cardLabel = wrapper.querySelector("[data-card-label]");
    var cardList = wrapper.querySelector("[data-card-list]");
    var cardHidden = wrapper.querySelector("[data-card-value]");
    var cardVariantHidden = wrapper.querySelector("[data-card-variant-id]");
    var cardTogglePrice = wrapper.querySelector("[data-card-toggle-price]");
    var seasonalNoshiToggle = wrapper.querySelector("[data-seasonal-noshi-toggle]");
    var seasonalNoshiNaire = wrapper.querySelector("[data-seasonal-noshi-naire]");
    var placementHidden = wrapper.querySelector('input[name="properties[のし配置]"]');

    var currentNoshiType = "";
    var submittingGift = false;

    if (!trigger || !panel) return;

    trigger.addEventListener("click", function () {
      var shouldOpen = panel.hidden;
      panel.hidden = !shouldOpen;
      trigger.setAttribute("aria-expanded", String(shouldOpen));
      updateSelectedIds();
    });

    wrapper
      .querySelectorAll(".gift-options__toggle")
      .forEach(function (toggle) {
        var targetId = toggle.getAttribute("data-target");
        var toggleKind = toggle.getAttribute("data-toggle-kind") || "";
        var isSimple = toggle.hasAttribute("data-simple-prop");

        toggle.addEventListener("change", function () {
          if (toggleKind === "noshi" && this.checked) {
            clearSeasonalNoshiSelection();
          }

          if (targetId) {
            var details = document.getElementById(targetId);
            if (details) {
              details.hidden = !this.checked;
              details.querySelectorAll("input, select").forEach(function (el) {
                el.disabled = !toggle.checked;
              });
              if (toggleKind === "noshi") {
                if (noshiBtn) noshiBtn.disabled = !this.checked;
                if (omotegakiBtn) omotegakiBtn.disabled = true;
              }
              if (toggleKind === "card" && cardBtn) {
                cardBtn.disabled = !this.checked;
              }
            }
            if (!this.checked) {
              clearSection(details);
              if (toggleKind === "noshi") {
                currentNoshiType = "";
                resetNoshi();
                resetOmotegaki();
              }
              if (toggleKind === "card") {
                resetCard();
              }
            }
          }

          if (isSimple) {
            var propName = toggle.getAttribute("data-prop-name");
            var propValue = toggle.getAttribute("data-prop-value") || "あり";
            if (propName) {
              var hiddenInput = findHiddenInputByName(wrapper, propName);
              if (hiddenInput) {
                hiddenInput.value = this.checked ? propValue : "";
                hiddenInput.disabled = !this.checked;
              }
            }
          }
          if (toggleKind === "seasonal-noshi") {
            setSeasonalNoshiSelection(this.checked);
          }
          updateSelectedIds();
        });
      });

    if (noshiBtn && noshiList) {
      noshiBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (this.disabled) return;
        noshiList.hidden = !noshiList.hidden;
        this.setAttribute("aria-expanded", String(!noshiList.hidden));
        closeOmotegaki();
        closeCard();
      });

      noshiList
        .querySelectorAll(".gift-options__custom-select-item")
        .forEach(function (li) {
          li.addEventListener("click", function () {
            var value = this.getAttribute("data-value") || "";
            var variantId = this.getAttribute("data-variant-id") || "";
            var variantPrice = this.getAttribute("data-variant-price") || "";

            currentNoshiType = value;
            if (noshiHidden) noshiHidden.value = value;
            if (noshiVariantHidden) noshiVariantHidden.value = variantId;
            if (noshiLabel) noshiLabel.textContent = value;
            if (noshiTogglePrice && variantPrice) {
              noshiTogglePrice.textContent = "+" + formatPriceJPY(variantPrice);
              noshiTogglePrice.setAttribute(
                "data-gift-price-cents",
                variantPrice,
              );
            }

            noshiList.querySelectorAll("li").forEach(function (el) {
              el.removeAttribute("aria-selected");
            });
            this.setAttribute("aria-selected", "true");
            closeNoshi();
            buildOmotegakiList(value);
            updateSelectedIds();
          });
        });
    }

    if (omotegakiBtn && omotegakiList) {
      omotegakiBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (this.disabled) return;
        omotegakiList.hidden = !omotegakiList.hidden;
        this.setAttribute("aria-expanded", String(!omotegakiList.hidden));
        closeNoshi();
        closeCard();
      });
    }

    if (cardBtn && cardList) {
      cardBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (this.disabled) return;
        cardList.hidden = !cardList.hidden;
        this.setAttribute("aria-expanded", String(!cardList.hidden));
        closeNoshi();
        closeOmotegaki();
      });

      cardList
        .querySelectorAll(".gift-options__custom-select-item")
        .forEach(function (li) {
          li.addEventListener("click", function () {
            var value = this.getAttribute("data-value") || "";
            var variantId = this.getAttribute("data-variant-id") || "";
            var variantPrice = this.getAttribute("data-variant-price") || "";

            if (cardHidden) {
              cardHidden.value = value;
              cardHidden.disabled = !value;
            }
            if (cardVariantHidden) {
              cardVariantHidden.value = variantId;
              cardVariantHidden.disabled = !variantId;
            }
            if (cardLabel) cardLabel.textContent = value || "選択してください";
            if (cardTogglePrice && variantPrice) {
              cardTogglePrice.textContent = "+" + formatPriceJPY(variantPrice);
              cardTogglePrice.setAttribute(
                "data-gift-price-cents",
                variantPrice,
              );
            }

            cardList.querySelectorAll("li").forEach(function (el) {
              el.removeAttribute("aria-selected");
            });
            this.setAttribute("aria-selected", "true");
            closeCard();
            updateSelectedIds();
          });
        });
    }

    document.addEventListener("click", function (e) {
      var noshiDropdown = wrapper.querySelector("[data-noshi-dropdown]");
      var omotegakiDropdown = wrapper.querySelector(
        "[data-omotegaki-dropdown]",
      );
      var cardDropdown = wrapper.querySelector("[data-card-dropdown]");
      if (noshiDropdown && !noshiDropdown.contains(e.target)) closeNoshi();
      if (omotegakiDropdown && !omotegakiDropdown.contains(e.target))
        closeOmotegaki();
      if (cardDropdown && !cardDropdown.contains(e.target)) closeCard();
    });

    var form =
      wrapper.closest('form[action*="/cart/add"]') || wrapper.closest("form");
    if (form) {
      form.addEventListener(
        "submit",
        function (e) {
          if (submittingGift) {
            e.preventDefault();
            return;
          }

          var selectedIds = updateSelectedIds();
          var noshiToggle = wrapper.querySelector('[data-toggle-kind="noshi"]');
          var cardToggle = wrapper.querySelector('[data-toggle-kind="card"]');
          var variantId = noshiVariantHidden ? noshiVariantHidden.value : "";

          if (noshiToggle && noshiToggle.checked && !variantId) {
            stopSubmit(e);
            alert("のしの種類を選択してください。");
            if (noshiBtn) {
              try {
                noshiBtn.focus();
              } catch (_) {}
            }
            return;
          }

          if (variantId && !(omotegakiHidden && omotegakiHidden.value)) {
            stopSubmit(e);
            alert("のしの表書きを選択してください。");
            if (omotegakiBtn) {
              try {
                omotegakiBtn.focus();
              } catch (_) {}
            }
            return;
          }

          if (
            cardToggle &&
            cardToggle.checked &&
            !(cardVariantHidden && cardVariantHidden.value)
          ) {
            stopSubmit(e);
            alert("シールの種類を選択してください。");
            if (cardBtn) {
              try {
                cardBtn.focus();
              } catch (_) {}
            }
            return;
          }

          if (selectedIds.length === 0) return;

          stopSubmit(e);
          var formData = new FormData(form);
          var rawId = formData.get("id");
          var mainItemId = rawId ? parseInt(rawId, 10) : NaN;
          if (isNaN(mainItemId)) {
            alert(
              "商品情報を取得できませんでした。ページを再読み込みしてから再度お試しください。",
            );
            return;
          }

          var mainQty = parseInt(formData.get("quantity"), 10) || 1;
          var properties = collectProperties(formData);
          properties._gift_options = "true";
          properties._gift_accessory_variant_ids = JSON.stringify(selectedIds);
          var sellingPlan = normalizeSellingPlan(formData.get("selling_plan"));

          var mainItem = {
            id: mainItemId,
            quantity: mainQty,
            properties: properties,
          };
          if (sellingPlan) mainItem.selling_plan = sellingPlan;

          var items = [mainItem];

          selectedIds.forEach(function (id) {
            var parsedId = parseInt(id, 10);
            if (isNaN(parsedId)) return;
            items.push({
              id: parsedId,
              quantity: mainQty,
              properties: { _gift_accessory: "true" },
            });
          });

          submittingGift = true;
          setSubmitting(form, true);

          fetch("/cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: items }),
          })
            .then(function (response) {
              if (!response.ok) {
                return response.json().then(
                  function (err) {
                    throw new Error(
                      err && err.description
                        ? err.description
                        : "カート追加に失敗しました",
                    );
                  },
                  function () {
                    throw new Error("カート追加に失敗しました");
                  },
                );
              }
              return updateCartAttributes(buildGiftAttributes(properties));
            })
            .then(function () {
              window.location.href = "/cart";
            })
            .catch(function (err) {
              console.error("[gift-options] cart add failed:", err);
              alert(err.message || "カート追加に失敗しました");
              submittingGift = false;
              setSubmitting(form, false);
            });
        },
        true,
      );
    }

    function updateSelectedIds() {
      var ids = [];
      var noshiId = noshiVariantHidden ? noshiVariantHidden.value : "";
      if (noshiId) ids.push(String(noshiId));

      var cardId = cardVariantHidden ? cardVariantHidden.value : "";
      if (cardId) ids.push(String(cardId));

      wrapper.querySelectorAll("[data-simple-prop]").forEach(function (toggle) {
        if (!toggle.checked) return;
        var id = toggle.getAttribute("data-extra-variant-id") || "";
        if (id) ids.push(String(id));
      });

      ids = ids.filter(function (id, index) {
        return id && ids.indexOf(id) === index;
      });

      if (giftFlag) giftFlag.disabled = ids.length === 0;
      if (selectedIdsInput) {
        selectedIdsInput.value = ids.length ? JSON.stringify(ids) : "";
        selectedIdsInput.disabled = ids.length === 0;
      }
      updateGiftSummary(ids);
      return ids;
    }

    function updateGiftSummary(ids) {
      if (!summary) return;
      var count = ids.length;
      if (count === 0) {
        summary.textContent = "未選択";
        return;
      }

      var total = 0;
      if (noshiVariantHidden && noshiVariantHidden.value) {
        total += readPriceCents(noshiTogglePrice);
      }
      if (cardVariantHidden && cardVariantHidden.value) {
        total += readPriceCents(cardTogglePrice);
      }
      wrapper.querySelectorAll("[data-simple-prop]").forEach(function (toggle) {
        if (!toggle.checked) return;
        var label = toggle.closest(".gift-options__toggle-label");
        total += readPriceCents(
          label ? label.querySelector("[data-gift-price-cents]") : null,
        );
      });

      summary.textContent =
        count + "件選択中 +" + formatPriceJPY(total || 0);
    }

    function buildOmotegakiList(noshiType) {
      if (!omotegakiList) return;
      omotegakiList.innerHTML = "";
      resetOmotegaki();

      var options = OMOTEGAKI_OPTIONS[noshiType];
      if (!options || options.length === 0) {
        if (omotegakiLabel)
          omotegakiLabel.textContent = "表書きを入力してください";
        if (omotegakiBtn) omotegakiBtn.disabled = false;
        return;
      }

      if (omotegakiLabel) omotegakiLabel.textContent = "選択してください";
      if (omotegakiBtn) omotegakiBtn.disabled = false;

      options.forEach(function (item) {
        var li = document.createElement("li");
        li.className = "gift-options__custom-select-item";
        li.setAttribute("role", "option");
        li.setAttribute("data-value", item.value);
        li.innerHTML =
          '<span class="gift-options__custom-select-item-value">' +
          item.value +
          "</span>" +
          '<span class="gift-options__custom-select-item-desc">（' +
          item.desc +
          "）</span>";
        li.addEventListener("click", function () {
          if (omotegakiHidden) omotegakiHidden.value = item.value;
          if (omotegakiLabel) omotegakiLabel.textContent = item.value;
          omotegakiList.querySelectorAll("li").forEach(function (el) {
            el.removeAttribute("aria-selected");
          });
          li.setAttribute("aria-selected", "true");
          closeOmotegaki();
        });
        omotegakiList.appendChild(li);
      });
    }

    function resetNoshi() {
      if (noshiHidden) noshiHidden.value = "";
      if (noshiVariantHidden) noshiVariantHidden.value = "";
      if (noshiLabel) noshiLabel.textContent = "選択してください";
      if (noshiBtn) noshiBtn.setAttribute("aria-expanded", "false");
      if (noshiList) {
        noshiList.hidden = true;
        noshiList.querySelectorAll("li").forEach(function (el) {
          el.removeAttribute("aria-selected");
        });
      }
    }

    function resetOmotegaki() {
      if (omotegakiHidden) omotegakiHidden.value = "";
      if (omotegakiLabel)
        omotegakiLabel.textContent = "のしの種類を先に選択してください";
      if (omotegakiList) {
        omotegakiList.innerHTML = "";
        omotegakiList.hidden = true;
      }
      if (omotegakiBtn) {
        omotegakiBtn.setAttribute("aria-expanded", "false");
        omotegakiBtn.disabled = true;
      }
    }

    function resetCard() {
      if (cardHidden) {
        cardHidden.value = "";
        cardHidden.disabled = true;
      }
      if (cardVariantHidden) {
        cardVariantHidden.value = "";
        cardVariantHidden.disabled = true;
      }
      if (cardLabel) cardLabel.textContent = "選択してください";
      if (cardBtn) {
        cardBtn.setAttribute("aria-expanded", "false");
        cardBtn.disabled = true;
      }
      if (cardList) {
        cardList.hidden = true;
        cardList.querySelectorAll("li").forEach(function (el) {
          el.removeAttribute("aria-selected");
        });
      }
    }

    function setSeasonalNoshiSelection(checked) {
      if (!seasonalNoshiToggle) return;

      var variantId = seasonalNoshiToggle.getAttribute("data-variant-id") || "";
      var value = seasonalNoshiToggle.getAttribute("data-variant-label") || "敬老の日";
      var omotegaki =
        seasonalNoshiToggle.getAttribute("data-fixed-omotegaki") || "敬老の日";

      if (!checked) {
        if (
          noshiVariantHidden &&
          String(noshiVariantHidden.value) === String(variantId)
        ) {
          resetNoshi();
          resetOmotegaki();
          if (noshiHidden) noshiHidden.disabled = true;
          if (noshiVariantHidden) noshiVariantHidden.disabled = true;
          if (omotegakiHidden) omotegakiHidden.disabled = true;
          if (placementHidden) placementHidden.disabled = true;
          if (seasonalNoshiNaire) seasonalNoshiNaire.value = "";
        }
        return;
      }

      var noshiToggle = wrapper.querySelector('[data-toggle-kind="noshi"]');
      if (noshiToggle) {
        noshiToggle.checked = false;
        var noshiDetailsId = noshiToggle.getAttribute("data-target");
        var noshiDetails = noshiDetailsId
          ? document.getElementById(noshiDetailsId)
          : null;
        if (noshiDetails) {
          noshiDetails.hidden = true;
          clearSection(noshiDetails);
        }
      }

      currentNoshiType = value;
      if (noshiHidden) {
        noshiHidden.value = value;
        noshiHidden.disabled = !value;
      }
      if (noshiVariantHidden) {
        noshiVariantHidden.value = variantId;
        noshiVariantHidden.disabled = !variantId;
      }
      if (omotegakiHidden) {
        omotegakiHidden.value = omotegaki;
        omotegakiHidden.disabled = !omotegaki;
      }
      if (placementHidden) {
        placementHidden.disabled = false;
      }
      if (seasonalNoshiNaire) {
        seasonalNoshiNaire.disabled = false;
      }
    }

    function clearSeasonalNoshiSelection() {
      if (!seasonalNoshiToggle) return;

      var variantId = seasonalNoshiToggle.getAttribute("data-variant-id") || "";
      seasonalNoshiToggle.checked = false;
      var detailsId = seasonalNoshiToggle.getAttribute("data-target");
      var details = detailsId ? document.getElementById(detailsId) : null;
      if (details) {
        details.hidden = true;
        clearSection(details);
      }
      if (
        noshiVariantHidden &&
        String(noshiVariantHidden.value) === String(variantId)
      ) {
        resetNoshi();
        resetOmotegaki();
        if (noshiHidden) noshiHidden.disabled = true;
        if (noshiVariantHidden) noshiVariantHidden.disabled = true;
        if (omotegakiHidden) omotegakiHidden.disabled = true;
        if (placementHidden) placementHidden.disabled = true;
        if (seasonalNoshiNaire) seasonalNoshiNaire.value = "";
      }
    }

    function closeNoshi() {
      if (noshiList) noshiList.hidden = true;
      if (noshiBtn) noshiBtn.setAttribute("aria-expanded", "false");
    }

    function closeOmotegaki() {
      if (omotegakiList) omotegakiList.hidden = true;
      if (omotegakiBtn) omotegakiBtn.setAttribute("aria-expanded", "false");
    }

    function closeCard() {
      if (cardList) cardList.hidden = true;
      if (cardBtn) cardBtn.setAttribute("aria-expanded", "false");
    }

    updateSelectedIds();
  }

  function stopSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") {
      e.stopImmediatePropagation();
    }
  }

  function normalizeSellingPlan(value) {
    var raw = String(value || "").trim();
    if (!raw) return null;
    if (/^\d+$/.test(raw)) return parseInt(raw, 10);
    return raw;
  }

  function setSubmitting(form, submitting) {
    form
      .querySelectorAll('button[type="submit"], input[type="submit"]')
      .forEach(function (button) {
        button.disabled = submitting;
        button.setAttribute("aria-busy", String(submitting));
      });
  }

  function buildGiftAttributes(properties) {
    var summary = buildGiftSummary(properties);
    return {
      ギフトオプション: summary,
      熨斗: properties["のし"] ? "有" : "",
      熨斗の種類: properties["のし"] || "",
      表書: properties["表書き"] || "",
      名前: properties["名入れ"] || "",
      手提げ袋: properties["手提げ袋"] || "",
      カード: properties["カード"] || "",
    };
  }

  function buildGiftSummary(properties) {
    var parts = [];
    if (properties["のし"]) {
      var noshi = "のし: " + properties["のし"];
      if (properties["表書き"]) noshi += " / 表書き: " + properties["表書き"];
      if (properties["名入れ"]) noshi += " / 名入れ: " + properties["名入れ"];
      parts.push(noshi);
    }
    if (properties["手提げ袋"]) {
      parts.push("手提げ袋: " + properties["手提げ袋"]);
    }
    if (properties["カード"]) {
      parts.push("シール: " + properties["カード"]);
    }
    return parts.join(" / ");
  }

  function collectProperties(formData) {
    var properties = {};
    formData.forEach(function (value, key) {
      if (key.indexOf("properties[") !== 0 || !value) return;
      var propName = key.replace("properties[", "").replace("]", "");
      properties[propName] = value;
    });
    return properties;
  }

  function clearSection(container) {
    if (!container) return;
    container.querySelectorAll("input").forEach(function (input) {
      if (input.type === "checkbox") input.checked = false;
      else if (!input.hasAttribute("data-default-value")) input.value = "";
      input.disabled = true;
    });
  }

  function resetAll(wrapper) {
    wrapper
      .querySelectorAll(".gift-options__toggle")
      .forEach(function (toggle) {
        toggle.checked = false;
      });
    wrapper
      .querySelectorAll(".gift-options__details")
      .forEach(function (details) {
        details.hidden = true;
        clearSection(details);
      });
    wrapper.querySelectorAll("[data-simple-prop]").forEach(function (toggle) {
      var propName = toggle.getAttribute("data-prop-name");
      if (!propName) return;
      var hiddenInput = findHiddenInputByName(wrapper, propName);
      if (hiddenInput) {
        hiddenInput.value = "";
        hiddenInput.disabled = true;
      }
    });
  }

  function updateCartAttributes(attributes) {
    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {});
  }

  function formatPriceJPY(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return "";
    return "¥" + (n / 100).toLocaleString("ja-JP");
  }

  function readPriceCents(el) {
    if (!el) return 0;
    var n = parseInt(el.getAttribute("data-gift-price-cents") || "", 10);
    return isNaN(n) ? 0 : n;
  }

  function findHiddenInputByName(wrapper, name) {
    var inputs = wrapper.querySelectorAll('input[type="hidden"]');
    for (var i = 0; i < inputs.length; i += 1) {
      if (inputs[i].name === name) return inputs[i];
    }
    return null;
  }
})();
